<script setup lang="js">
import { ref } from 'vue';
import Download from './download.vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const channel = ref(route.params?.channel);
const isActive = (path) => {
  return route.path === path;
};
const CategoriesPath = channel.value ? `/${channel.value}/playlets` :'/playlets';
const AudioPath = channel.value ? `/${channel.value}/audio` :'/audio';
const NovelsPath = channel.value ? `/${channel.value}/novels` :'/novels';
const navItems = [
  { path: `/${channel.value}`, name: 'Home' },
  { path: CategoriesPath, name: 'Categories' },
  { path: AudioPath, name: 'Audio' },
  { path: NovelsPath, name: 'Novels' }
];
</script>
<template>
  <div class="navView">
    <div class="navContent">
      <div class="w-[1080px] m-auto">
        <div class="h-full flex items-center">
          <div class="logo"></div>
          <div v-for="item in navItems" :key="item.path" class="bar" :class="{ 'bar-active': isActive(item.path) }">
            <RouterLink :to="item.path">{{ item.name }}</RouterLink>
          </div>
          <Download  class="bar" />
        </div>
      </div>
    </div>
    <div class="w-full h-[56px]"></div>
  </div>
  <!-- 移动端导航 -->
  <header class="mobile-nav">
    <div class="head-top">
      <div class="head-logo"></div>
      <!-- 隐藏无意义的用户头像 -->
      <!-- <div class="head-user"></div> -->
    </div>
    <div class="head-list">
      <div class="head-nav">
        <div v-for="item in navItems" :key="item.path" :class="{ 'avtive': isActive(item.path) }">
          <RouterLink :to="item.path">{{ item.name }}</RouterLink>
        </div>
        <Download />
      </div>
    </div>
  </header>
</template>
<style scoped>
.navView {
  @apply hidden md:block;
}
.navContent {
  @apply m-auto h-[56px] fixed top-0 bg-white w-full border-b-2 right-0 z-50;
}
.logo {
  @apply w-[40px] h-[40px] bg-[rgb(var(--theme-color))] bg-[url('../assets/logo.jpg')] rounded-[6px] bg-no-repeat bg-center bg-[length:20px_20px] mr-[28px];
}
.bar {
  @apply md:text-[18px] md:h-[56px] md:px-[16px] text-[#222] leading-[56px] cursor-pointer hover:text-[rgb(var(--theme-color))];
}
.bar-active {
  @apply text-[rgb(var(--theme-color))];
}
/* 移动端导航 */
.mobile-nav {
  @apply md:hidden bg-[rgb(var(--theme-color))] sticky top-0 left-0 w-full z-30;
  padding: 0.18667rem 0.42667rem 0;
}
.head-top {
  @apply flex items-center justify-between;
}
.head-logo {
  @apply w-[.90667rem] h-[.90667rem] bg-[#fff] bg-[url('../assets/logo.jpg')] rounded bg-no-repeat bg-center bg-[length:.90667rem.90667rem];
}
.head-user {
  @apply w-[.85333rem] h-[.85333rem] bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNpcmNsZS11c2VyLXJvdW5kIj48cGF0aCBkPSJNMTggMjBhNiA2IDAgMCAwLTEyIDAiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEwIiByPSI0Ii8+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiLz48L3N2Zz4=')] bg-no-repeat bg-center bg-[length:.85333rem_.85333rem];
}
.head-list {
  @apply h-[1.17333rem] overflow-hidden;
}
.head-nav {
  @apply h-[1.28rem] flex justify-start w-[8.05333rem];
}
.head-nav > div {
  @apply leading-[1.17333rem] text-center mr-[.42667rem] text-[.34667rem] relative;
  color: rgb(0, 0, 0, 0.7);
}
.head-nav > div.avtive {
  @apply text-[#000] after:inline-block after:h-[.08rem] after:w-[.85333rem] after:bg-[#000] after:bottom-[.10667rem] after:translate-x-[-50%] after:left-2/4 after:absolute;
}
</style>
